import type { ReactNode } from "react";
import { Icon } from "./Icon.js";

export interface CalloutProps {
  children: ReactNode;
  iconName?: string;
}

export function Callout({ children, iconName = "sparkle" }: CalloutProps) {
  return (
    <div className="callout">
      <div className="callout-icon">
        <Icon name={iconName} size={16} />
      </div>
      <div>{children}</div>
    </div>
  );
}
